<template>
  <div class="section">
    <div class="max-width">
      <div class="built">

        <div class="section__head section__head_middle">
          <div class="section__subheading section__subheading_themes fadeIn">Everything</div>
          <h2 class="section__title">you need for Powerful Store</h2>
          <div class="section__text">Every element is designed with purpose to drive sales, engage customers, and grow your store.</div>
        </div>

        <div class="built__grid">
          <div class="built__card fadeIn">
            <div class="built__icon">
              <img src="/assets/imgs/themes/built-icon-1.svg" alt="">
            </div>
            <h3 class="built__label">User-Friendly Design</h3>
            <div class="built__desc">Professional, clean, and modern — our themes combine stylish design with user-friendly functionality.</div>
          </div>

          <div class="built__card fadeIn">
            <div class="built__icon">
              <img src="/assets/imgs/themes/built-icon-2.svg" alt="">
            </div>
            <h3 class="built__label">Responsive & Mobile-Optimized</h3>
            <div class="built__desc">Fully responsive themes that adapt to desktops, tablets, and mobile devices for consistent user experience.</div>
          </div>

          <div class="built__card fadeIn">
            <div class="built__icon">
              <img src="/assets/imgs/themes/built-icon-3.svg" alt="">
            </div>
            <h3 class="built__label">Customization Options</h3>
            <div class="built__desc">With user-friendly controls and versatile settings, our themes make building a unique, branded store effortless.</div>
          </div>

          <div class="built__card fadeIn">
            <div class="built__icon">
              <img src="/assets/imgs/themes/built-icon-4.svg" alt="">
            </div>
            <h3 class="built__label">Fast Loading Times</h3>
            <div class="built__desc">Optimized for speed to keep visitors engaged, lower bounce rates, and boost your SEO rankings.</div>
          </div>

          <div class="built__card fadeIn">
            <div class="built__icon">
              <img src="/assets/imgs/themes/built-icon-5.svg" alt="">
            </div>
            <h3 class="built__label">Regular Updates</h3>
            <div class="built__desc">Improvements and updates delivered regularly, ensuring a smooth, secure, and efficient operation of your site.</div>
          </div>

          <div class="built__card fadeIn">
            <div class="built__icon">
              <img src="/assets/imgs/themes/built-icon-6.svg" alt="">
            </div>
            <h3 class="built__label">Cross-Browser Compatibility</h3>
            <div class="built__desc">Tested across all major browsers to guarantee consistent design and performance for every visitor.</div>
          </div>

          <div class="built__card fadeIn">
            <div class="built__icon">
              <img src="/assets/imgs/themes/built-icon-7.svg" alt="">
            </div>
            <h3 class="built__label">Easy to Set Up</h3>
            <div class="built__desc">Our theme allows you to create an professional-looking online store with no coding, making setup seamlessly simple.</div>
          </div>

          <div class="built__card fadeIn">
            <div class="built__icon">
              <img src="/assets/imgs/themes/built-icon-8.svg" alt="">
            </div>
            <h3 class="built__label">One-of-a-Kind Support</h3>
            <div class="built__desc">We respond to your request within 15 minutes — day or night, weekday or weekend. Full support is available 24/7, even on trial.</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
  .built {
    .section__head {
      max-width:850px;
    }

    &__grid {
      display:flex;
      justify-content:center;
      flex-wrap:wrap;
      gap:1.25rem;

      @include md {
        grid-template-columns:repeat(2,1fr);
        display:grid;
      }

      @include xs {
        grid-template-columns:repeat(1,1fr);
        gap:1.25rem;
      }
    }

    &__card {
      flex:0 0 calc(33.3% - 14px);
      padding:2rem 2rem 3.25rem;
      border-radius:24px;
      background:var(--color-gray-light);

      @include lg {
        padding:2rem;
      }

      @include md {
        flex:initial;
      }

      @include xs {
        padding:1.5rem;
      }
    }

    &__icon {
      margin:0 0 1.5rem;
    }

    &__label {
      font-size:1.25rem;
      margin:0 0 .5rem;
      font-weight: 900;
      line-height: 120%;
      letter-spacing: -0.01em;
      font-family:var(--font-family);
      text-transform: uppercase;
    }

    &__desc {
      font-size:.875rem;
    }
  }
</style>
<script setup>
</script>
